import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { getHomepageUrl } from '@as-react/common-utils';
import { useEffect } from 'react';
import { useOAuth } from '../hooks/useOAuth';
import { usePageShow } from '../hooks/usePageShow';
import { mimicDelay } from '../util/GeneralUtil';
import { getQueryStringParameter } from '../util/UrlUtil';
const LoginContainer = ({ redirectLink }) => {
    const { root, isInAuthorMode } = useAemConfig();
    const flow = getQueryStringParameter('flow');
    const { redirectToLogin, isLoggedIn, loginState } = useOAuth({
        returnTo: redirectLink || getHomepageUrl(root),
        cancelUrl: getHomepageUrl(root),
        flow,
    });
    usePageShow();
    useEffect(() => {
        const redirectUser = () => __awaiter(void 0, void 0, void 0, function* () {
            yield mimicDelay();
            window.location.href = redirectLink || getHomepageUrl(root);
        });
        if (loginState === 'PENDING') {
            return;
        }
        if (isLoggedIn) {
            redirectUser();
        }
        else if (!isInAuthorMode) {
            redirectToLogin();
        }
    }, [isLoggedIn, loginState]);
    return null;
};
export default LoginContainer;
